<template>
  <div>
    <b-alert class=mt-4 sm="6" show dismissible variant="info">
        {{ $t("info.chooseUnit") }}    
    </b-alert>
  <b-form>
    <b-row class="pt-4">
      <b-col>
        <h3>{{$t('label.unitChoice')}}</h3>
      </b-col>
    </b-row>
    <div v-if="currentUnit.length > 0" class="mt-2">
      <AlertSelectedUnit :selectedUnit="selectedUnit"/>
    </div>

      <!--<b-row class="mt-2">
        <b-col sm="4" class="mt-4">
          <b-form-select v-model.trim="$v.province.$model" :options="provinces"></b-form-select>
          <div class="text-danger" v-if="!$v.province.required && $v.province.$dirty">{{ $t("info.required") }}</div>
        </b-col>     
      </b-row>-->
      
      <b-row class="mt-2">
        <b-col sm="4" class="mt-4">
          <b-form-select v-model.trim="$v.building.$model" :options="buildings" v-on:change="OnBuildingClick"></b-form-select>
          <div class="text-danger" v-if="!$v.building.required && $v.building.$dirty">{{ $t("info.required") }}</div>
        </b-col>     
      </b-row>

      <b-row class="mt-2">
        <b-col sm="4" class="mt-4">
          <b-form-select v-model.trim="$v.nbPiece.$model" :options="nbPieces"></b-form-select>
          <div class="text-danger" v-if="!$v.nbPiece.required && $v.nbPiece.$dirty">{{ $t("info.required") }}</div>
        </b-col>     
      </b-row>

    <b-row class="mt-2" >      
              <b-col sm class="mt-4">
                <h5>{{$t("label.chooseRentalDate")}}</h5>
                  <month-picker
                  v-model.trim="$v.startDate.$model"
                  :lang="selectedLang"
                  :clearable="isClearable"
                  :editable-year="isEditableYear"
                  :variant="selectedVariant"
                  :show-year="showYear"
                  :max-date="maxDate !== null ? new Date(maxDate) : null"
                  :min-date="minDate !== null ? new Date(minDate) : null"
                  :year-only="isYearOnly"
                  :range="isRange"
                  :default-month="defaultMonth"
                  :default-year="defaultYear"
                  @change="showDate"
                  @change-year="(v) => year = v"
                  @clear="showClearText"
              />
              </b-col>
          </b-row>
    <div class="text-danger" v-if="!$v.startDate.required && $v.startDate.$dirty">{{ $t("info.required") }}</div>

    <div><b-button class="mt-4" variant="success" @click="onSubmit()" :disabled="disabled">{{ $t("label.submit") }}</b-button></div>

    </b-form>

    <!-- spinner -->
    <div v-if="spinner" class="text-center pt-2">
      <b-spinner style="width: 3rem; height: 3rem;" variant="success" label="Spinning" disabled="labelStatus"></b-spinner>
    </div>

    <div v-if="errorNoData" class="pt-4">
    <b-alert show variant="warning">
        <p>{{$t('info.noUnit')}}</p>
    </b-alert>
    </div>

    <!-- error -->
    <div v-if="error" class="pt-4">
        <b-alert sm="6" show variant="danger">
            <p>{{ error }}</p>
        </b-alert>
    </div>

    <div v-if="units.length > 0">

        <hr />

        <div v-if="selected.length > 0" class="pt-4">
        <b-navbar class="fixed-bottom openPst">
            <div v-if="btnNextStep" class="col text-center">
                <b-button size="lg" variant="success" @click="AddUnit('updateUnit')">{{ $t("label.updateUnit") }} </b-button>
            </div>
            <div v-else class="col text-center">
                <b-button size="lg" variant="success" @click="AddUnit('setApplicationsProcess')">{{ $t("label.addUnit") }} </b-button>
            </div>
        </b-navbar>
        </div>

        <b-row class="pt-2">
        <b-col sm="4" class="mt-2">
          <b-form-input v-model="search" :placeholder="$t('label.search')"></b-form-input>
        </b-col>

        <b-col sm="4" class="mt-2">
          <div>{{ $t("label.tablesize") }} {{ items.length }}</div>
        </b-col>

      </b-row>

    <b-row class="pt-4">
      <b-col class="xlTable">
        <b-table 
        stacked="xl"
        bordered
        :fields="myfields"
        :items="items"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :current-page="currentPage"
        >
        <template v-slot:cell(details)="row">
            <b-button size="sm" @click="row.toggleDetails">
              {{ row.detailsShowing ? $t("label.hide") : $t("label.show") }}
            </b-button>
            <b-button class="ml-2" size="sm" :variant="row.item.variant" @click="onRowSelected(row.item)">{{ row.item.variant === 'success' ? $t("label.selected") : $t("label.choose") }}</b-button>
        </template>
        <template v-slot:row-details="row">
            <b-container fluid>      
            <div><strong>{{ $t("label.unitinfo") }}</strong></div>
            <b-row>
                {{/*unite*/}}
                <b-col sm="3" v-if="row.item.ETAGE">{{ $t("label.floor") }} : {{row.item.ETAGE}}</b-col>
                <b-col sm="3" v-if="row.item.SFICIE">{{ $t("label.surface") }} : {{row.item.SFICIE}}</b-col>
                <b-col sm="3" v-if="row.item.ORIENT">{{ $t("label.orientation") }} : {{row.item.ORIENT}}</b-col>
            </b-row>
            </b-container> 
        </template>
      </b-table>
    </b-col>
  </b-row>
    </div>
    
</div>
</template>

<script>
  import axios from 'axios';
  import moment from 'moment';
  import { MonthPicker } from 'vue-month-picker';
  //import Datepicker from 'vuejs-datepicker';
  import {en, fr} from 'vuejs-datepicker/dist/locale';
  import { required } from 'vuelidate/lib/validators';  
  import AlertSelectedUnit from './AlertSelectedUnit';
  import { globalF } from './Helpers';

  export default {  
  mixins: [globalF],  
  props: ['btnNextStep'],
    data() {
      return {   
        currentUnit: this.getSelected(),
        selected: [],
        error: "",
        errorNoData: false,
        spinner: false,       
        province: this.getProvince(),
        building: this.getBuilding(),
        nbPiece: this.getNbPiece(),
        buildings: [],
        units: this.getUnitsRequest(),
        startDate: this.getStartDate(),
        disabled: false,
        sortBy: 'DATEDEP',
        sortDesc: true,
        perPage: 50,
        currentPage: 1,//this.getcurrentPage(),
        pages: [
          { value: 5, text: "5" },
          { value: 10, text: "10" },
          { value: 25, text: "25" },
          { value: 50, text: "50" },
          { value: 100, text: "100" },
        ],
        search: this.getSearch(),
        /*Month Picker*/
        year: 0,
        clearEmittedText: null,
        isMonthPickerVisible: false,
        isClearable: false,
        isEditableYear: false,
        isYearOnly: false,
        isRange: false,
        showYear: true,
        selectedDate: null,
        variants: ['default', 'dark'],
        selectedVariant: 'default',
        defaultMonth: this.getDefaultMonth(),
        defaultYear: this.getDefaultYear()
      }
    },
    validations() {
        return {        
          building: {
            required
          },
          province: {
            required
          },
          nbPiece: {
            required
          },
          startDate: {
            required
          }
        }
    },
    mounted () {
        this.spinner = true;
        let promise = this.setAxios('Step0');
        promise.then(() => {
          this.getBuildingList();
        });    
    },
    computed: { 
    englishRoomSize: function () {
      let building = this.building;
      let enRooms = false;
      if (building) {
        if (building.NOCIE === 899 && (building.NODIV === 2 || building.NODIV === 4)) {
          enRooms = true;
        }
      }
      return enRooms;
    },
    selectedUnit: function () {
      let buldingsList = this.$store.getters.getBuildings;
      //let selectedFromQueryString = this.getQueryStringValue();
      let selected = this.currentUnit;
      /*if (selectedFromQueryString.length > 0) {
        selected = selectedFromQueryString;
      }*/
      let buildFormat = {};
      if (selected.length > 0) {
        let build = buldingsList.find(b => b.NOCIE === selected[0].NOCIE && b.NODIV === selected[0].NODIV && b.Immeuble.trim() === selected[0].IMMEUBLE.trim());
        buildFormat.name = build.NOMDIV+ " ("+  build.Street + ", " + build.City + ", " + build.Province+" )";
        buildFormat.unit = " # " +selected[0].UNITE;
        buildFormat.specs = {NBPIECE: selected[0].NBPIECE, publicUnitPrice: selected[0].publicUnitPrice, DATEENT: moment(this.startDate.from).format("YYYY-MM-DD") };//moment(selected[0].DATEDEP).add(1, 'd').format("YYYY-MM-DD")};
      }
      return buildFormat;
    },
    url: function () {
        let urls = this.$store.getters.getUrlsList;
        return urls[process.env.VUE_APP_WHERE].json;
     },
      minDate: function () {
        return moment().toDate();
      },
      maxDate: function () {
        let mydate = moment().add(1.5, "years");
        return moment(mydate).toDate();
      },
      selectedLang: function () {
        return this.$i18n.locale;
      },
      provinces: function () {
          return [
              {value: null, text: 'Province'},
              {value: 1, text: 'Québec'},
              {value: 2, text: 'Ontario'}
              ];
      },
      language: function () {
        return this.$i18n.locale === "fr" ? fr : en;
      },
      disabledStartDate: function () {
        return {from: this.maxDate , to: this.minDate};
      },
      items: function () {
        return this.getUnitsList(this.units, this.search);
      },
      myfields:function () {
        return [          
          { key: 'UNITE', sortable: true, label: this.$tc('label.unitlabel', 1) },
          { key: 'NBPIECE', sortable: true, label: this.$t('label.nbpieceslabel') },
          { key: 'DATEDEP', sortable: true, label: this.$t('label.disponibility'), formatter: (value) => {return moment(value).add(1, 'd').format("YYYY-MM-DD")} },
          { key: 'publicUnitPrice', sortable: true, label: this.$t('label.price'), formatter: (value) => {return value+" $"} },
          { key: 'details', label: 'Details' },
        ]
      },
      nbPieces: function () {
        return [
          { value: null, text: this.$t("label.nbPiece")},
          { value: "1.5", text: !this.englishRoomSize ? "1.5" : "Studio"},
          { value: "2.5", text: !this.englishRoomSize ? "2.5" : "1 bed (small)"},
          { value: "3.5", text: !this.englishRoomSize ? "3.5" : "1 bed (large)"},
          { value: "4.5", text: !this.englishRoomSize ? "4.5" : "2 beds"},
          { value: "5.5", text: !this.englishRoomSize ? "5.5" : "3 beds"},
        ]
      }
    },
    methods:{
    OnBuildingClick() {

      this.units = [];
    },
    AddUnit(request) {
        let obj = {
            selected: this.selected,
            province: this.province,
            building: this.building,
            startDate: this.startDate,
            nbPiece: this.nbPiece
        }

        this.error = "";
        this.spinner = true;

            axios.post(this.url, {request: request, jsonData: JSON.stringify(obj)  }, { headers: {'Content-Type': 'application/json'}})
                .then((response)  => {
                    this.spinner = false;

                    if (response.data.status === 0) {
                        this.setNextPage('ApplicationsProcess');
                        //localStorage.removeItem("BuildingUnit");
                        window.location.reload(true);
                    }
                    else {
                        this.error = this.$t('info.errorgeneric');
                    }
                    
                })
                .catch(()  => {
                    this.error = this.$t('info.errorgeneric');
                    this.spinner = false;
                }); 
    },
    onRowSelected(itemlst) {
        this.addRemoveItemSelected(itemlst);
      },
    addRemoveItemSelected(itemlst) {
        let s = this.selected;
        let table = this.units;
        
        if (s.length > 0) {
          let currentIdRowTable = table.findIndex(u => u.NOCIE === s[0].NOCIE && u.NODIV === s[0].NODIV && u.IMMEUBLE === s[0].IMMEUBLE && u.UNITE === s[0].UNITE);
          table[currentIdRowTable].variant = 'outline-secondary';
        }

        let newIdRowTable = table.findIndex(u => u.NOCIE === itemlst.NOCIE && u.NODIV === itemlst.NODIV && u.IMMEUBLE === itemlst.IMMEUBLE && u.UNITE === itemlst.UNITE);
        table[newIdRowTable].variant = 'success';
          
        this.selected = [];
        this.selected.push(itemlst);
      },
    getUnitsRequest: function () {
      //this.onSubmit();
      let province = this.getProvince();
      let building = this.getBuilding();
      let nbPiece = this.getNbPiece();
      let startDate = this.getStartDate();
      if (province && building && nbPiece && startDate) {
        return this.setUnitsRequestList(province, building, nbPiece, startDate);
      }
      else {
         return [];
      }
    },
    getUnitsList: function (mydatalist, search) {
        let s = search.toLowerCase();
        return mydatalist.filter(u => u.UNITE.toLowerCase().includes(s) || u.NBPIECE.toLowerCase().includes(s) 
        || u.publicUnitPrice === s || u.DATEDEP.toLowerCase().includes(s));
      },
    getProcessData() {
      let processData = this.$store.getters.getProcessData;
      let step0data = processData[0];
      return step0data;
    },
    getSelected() {
      let processData = this.getProcessData();
      
      let selected = [];
      if (processData && processData.hasOwnProperty('selected')) {      
        selected = processData.selected;
      }

      return selected;
    },
    getProvince() {
      /*let processData = this.getProcessData();
      let province = null;
      if (processData && processData.hasOwnProperty('province')) {
        province = processData.province;
      }

      let selectedFromQueryString = this.getQueryStringValue();
      if (selectedFromQueryString.length > 0) {
        //let sel = selectedFromQueryString[0];
        province = 1;
      }*/
      
      return 1;
    },
    getNbPiece() {
      let processData = this.getProcessData();
      let nbPiece = null;
      if (processData && processData.hasOwnProperty('nbPiece')) {
        nbPiece = processData.nbPiece;
      }

      let selectedFromQueryString = this.getQueryStringValue();
      if (selectedFromQueryString.length > 0) {
        let sel = selectedFromQueryString[0];
        if (sel.hasOwnProperty("NBPIECE")) {
          nbPiece = sel.NBPIECE;
        }
      }

      return nbPiece;
    },
    getBuilding() {
      let processData = this.getProcessData();
      let building = null;
      if (processData && processData.hasOwnProperty('building')) {
        building = processData.building;
      }

      let selectedFromQueryString = this.getQueryStringValue();
      if (selectedFromQueryString.length > 0) {
        let sel = selectedFromQueryString[0];
        let buldingsList = this.$store.getters.getBuildings;
        let build = buldingsList.filter(b => b.NOCIE === sel.NOCIE && b.NODIV === sel.NODIV);
        let val = this.getUniqueValue(build);
        if (val[0]) {
          building = val[0];
        }
      }

      return building;
    },
    getSearch() {
      return "";
    },
    getStartDate() {
      let processData = this.getProcessData();
      let startDate = "";
      if (processData && processData.hasOwnProperty('startDate')) {
        //startDate = moment(processData.startDate).toDate();
        startDate = processData.startDate;
      }
      return startDate;
    },
    getDefaultMonth() {
      let processData = this.getProcessData();
      let month = moment().month();
      if (processData && processData.hasOwnProperty('startDate')) {
        month = moment(processData.startDate.from).month();
        month = month + 1;
      }
      return month;
    },
    getDefaultYear() {
      let processData = this.getProcessData();
      let year = moment().year();
      if (processData && processData.hasOwnProperty('startDate')) {
        year = moment(processData.startDate.from).year();
      }
      return year;
    },
    showClearText() {
      this.clearEmittedText = "emitted";
      window.setTimeout(() => {
        this.clearEmittedText = null;
      }, 1000);
    },
    showDate(date) {
      this.startDate = date;
    },
    formatDate(date) {
      return moment(date).subtract(1, 'months').format('YYYY-MM-DD');
    },
    getBuildingList() {
      let buldingsList = this.$store.getters.getBuildings;
      this.formatBuildingList(buldingsList);
      this.spinner = false;
    },
    onSubmit()  {
        
        this.error = "";
        this.$v.$touch();

        if (!this.$v.$invalid) {
          this.units = this.setUnitsRequestList(this.province, this.building, this.nbPiece, this.startDate);
        }
    },
    setUnitsRequestList: function (province, building, nbPiece, startDate) {

      this.units = [];
      this.selected = [];

      this.errorNoData = false;
      //let date1 = this.formatDate(this.startDate.from);
      let date2 = this.formatDate(startDate.to);

      let publicUnits = this.$store.getters.getPublicUnits;
      let allUnits = this.formatPublicUnits(publicUnits);

      //let selectedFromQueryString = this.getQueryStringValue();

      let units = [];

      /*if (selectedFromQueryString.length > 0 && selectedFromQueryString[0].NOCIE === building.NOCIE && selectedFromQueryString[0].NODIV === building.NODIV) {
        units = selectedFromQueryString;
      }*/

      //else {
        units = allUnits.filter(a => 
        a.NOCIE === building.NOCIE && a.NODIV === building.NODIV &&
        moment(a.DATEDEP).isBefore(date2) &&
        a.NBPIECE === nbPiece
        );
      //}

      if (units.length === 0) {
        this.errorNoData = true;
      }

      return units;
    },
    formatBuildingList(buildings) {
        if (buildings.length > 0) {
            let builds = this.mappBuildingDataForSelect(buildings);            
            let queryStringValue = this.getQueryStringValue();
            if (queryStringValue.length > 0) {
              let buildInfo = queryStringValue[0];
              let only = builds.filter(b => b.value.NOCIE === buildInfo.NOCIE && b.value.NODIV === buildInfo.NODIV);
              this.buildings = only;
            }
            else {
              builds.unshift({value: null, text: this.$t('label.properties')});
              this.buildings = builds;
            }
        }
    },
    formatUnitsList(units) {
        if (units.length > 0) {
            this.units = this.filterUnitsList(units);
        }
    },
    getUniqueValue(buildings) {
    let array = [];
    for (let i = 0; i < buildings.length; i++) {
        let ind = array.findIndex(a => a.NOCIE === buildings[i].NOCIE && a.NODIV ===  buildings[i].NODIV);
        if (ind === -1) {
        let obj = {
            Id: buildings[i].Id,
            NOCIE: buildings[i].NOCIE,
            NODIV: buildings[i].NODIV,
            NOMDIV: buildings[i].NOMDIV
        }
        array.push(obj);
        }
    }
    return array;
    },
    //Élimination des doublons, unité unique. Formatage des dates.
      filterUnitsList: function (list) {

        let newlist = [];
        for (let i = 0; i < list.length; i++) {
          //formatage des dates pour le reste de l'application
          list[i].DATEDEP = this.formatSqlDate(list[i].DATEDEP);
          list[i].DATEENT = this.formatSqlDate(list[i].DATEENT);

          let obj = {DATEDEP: list[i].DATEDEP, DATEENT: list[i].DATEENT};

          let id = newlist.findIndex(u => u.NOCIE === list[i].NOCIE && u.NODIV === list[i].NODIV && u.IMMEUBLE === list[i].IMMEUBLE && u.UNITE === list[i].UNITE);
          if (id === -1) {
            list[i].locarr = [obj];
            newlist.push(list[i]);
          }
          else {
            newlist[id].locarr.push(obj);
          }
        }

        newlist.map(function(u) { u.variant = "outline-secondary"; return u; });
         
        return newlist;
      },
    formatSqlDate(value) {
        let mydate = null;
        if (value && value.date) {
            mydate = moment(value.date).format('YYYY-MM-DD');
        }   
        return mydate;
    },
    mappBuildingDataForSelect(buildings) {
        let array = [];
        let unique = this.getUniqueValue(buildings);
        for (let i = 0; i < unique.length; i++) {
            let options = {};
            options.value = unique[i];
            options.text = unique[i].NOMDIV;
            array.push(options);
        }
        return array;
    },
    setNextPage(page) {
        this.$emit('changePage', page);
    },
    setNextStep(step) {
      this.$emit('changeStep', step);
    }
},
components: {
    //Datepicker,
    MonthPicker,
    AlertSelectedUnit
  }
}
</script>
